import { HorizontalLayout, VerticalLayout } from "../components/layout";
import { IconButton } from "../atoms/buttons";
import { InputFile, InputForm } from "../atoms/input";
import { act, use, useEffect, useRef, useState } from "react";
import { Alert } from "../components/alert";

export default function UploadMedia({ setMedia, media, textTranscriptionFailed }) {
    const audioRef = useRef();
    const videoRef = useRef();
    const [error, setError] = useState("");
    const [activeType, setActiveType] = useState(null);
    const MAX_DURATION = 30 * 60; 
    const parseYoutubeUrl = (url) => {
        try {
            const parsed = new URL(url);

            const isYoutubeDomain =
                parsed.hostname === "www.youtube.com" ||
                parsed.hostname === "youtube.com" ||
                parsed.hostname === "youtu.be";

            if (!isYoutubeDomain) return { valid: false };

            if (parsed.searchParams.has("list")) {
                return { valid: false, reason: "list_not_allowed" };
            }

            if (parsed.hostname === "youtu.be") {
                const id = parsed.pathname.slice(1);
                if (!/^[\w-]{11}$/.test(id)) return { valid: false };

                const cleanedUrl = `https://youtu.be/${id}`;

                return {
                    valid: true,
                    id,
                    cleanedUrl
                };
            }
            if (parsed.pathname === "/watch") {
                const id = parsed.searchParams.get("v");
                if (!id || !/^[\w-]{11}$/.test(id)) return { valid: false };
                const cleanedUrl = `https://www.youtube.com/watch?v=${id}`;

                return {
                    valid: true,
                    id,
                    cleanedUrl
                };
            }

            return { valid: false };

        } catch {
            return { valid: false };
        }
    };


    const handleYoutubeInput = (value) => {
        const result = parseYoutubeUrl(value);

        if (result.valid) {
            setMedia(result.cleanedUrl);
            setActiveType("youtube");
            setError("");
        } else {
            if (result.reason === "list_not_allowed") {
                setError("Playlist links worden niet ondersteund");
            } else {
                setError("Ongeldige YouTube link");
            }

            setMedia(null);
            setActiveType(null);
        }
    };


    const handleError = () => {
        if (textTranscriptionFailed){
            setError("");
        }
    }
    const uploadsTypes = [
        {
            title: "Audio",
            id: "audio",
            ref: audioRef,
            input: (<InputFile ref={audioRef} icon2="audio" accept="audio/*" fileChange={(e) => handleFileChange(e.target.files[0], "audio")} placeholder="Upload hier de audio..."/> )
        },
        {
            title: "Video",
            id: "video",
            ref: videoRef,
            input: (<InputFile ref={videoRef} icon2="video" accept="video/*" fileChange={(e) => handleFileChange(e.target.files[0], "video")} placeholder="Upload hier de video..." />)
        },
        {
            title: "YouTube",
            id: "youtube",
            input: ( <InputForm typeInput={handleYoutubeInput} placeholder="Plak hier de YouTube link..."/>
            )
        }
    ];

    const [pendingClickRef, setPendingClickRef] = useState(null);

    useEffect(() => {
        if (pendingClickRef?.current) {
            pendingClickRef.current.click();
            setPendingClickRef(null); 
        }
    }, [pendingClickRef]);
    useEffect(() => {
        handleError();
    }, [textTranscriptionFailed]);


    const handleClick = (type) => {
        if (activeType !== type.id) {
            setActiveType(type.id);
            setError("");
            if (type.ref) setPendingClickRef(type.ref);
        } else {
            setActiveType(null);
            setError("");
        }
    };

    const handleFileChange = (file, type) => {
        if (!file) return;

        const url = URL.createObjectURL(file);
        const mediaElement = document.createElement(type);
        mediaElement.src = url;

        mediaElement.onloadedmetadata = () => {
            if (mediaElement.duration > MAX_DURATION) {
                setError(`Het ${type} bestand is te lang. Maximaal ${MAX_DURATION / 60} minuten toegestaan.`);
                setMedia(null);
            } else {
                setError("");
                setMedia(file);
                setActiveType(type);
            }
        };
    };

    const mediaType = activeType === "video" || activeType === "audio"
    return (
        <VerticalLayout className="upload-media-wrapper">
            <HorizontalLayout className="upload-media-options" style={{ gap: ".5rem",  }}>
                {uploadsTypes.map(type => (
                    <IconButton
                        key={type.id}
                        icon2={type.id}
                        className={`media-icon-button ${activeType === type.id ? "selected" : ""}`}
                        onClick={() => handleClick(type)}
                        title={type.title}
                    />
                ))}
                 {activeType && (
                    <div className={`upload-media-input ${media && mediaType && "active"}`}>
                        {uploadsTypes.find(t => t.id === activeType)?.input}
                    </div>
                )}
            </HorizontalLayout>
            {error && (
                <Alert
                    className="standard-small-margin-top"
                    type="error"
                    message={error}
                />
            )}
        </VerticalLayout>
    );
}
